import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectLMSCollectionsListItems } from '../../../../../redux/lms/collections/selector';
import { selectLMScoursesListItems } from '../../../../../redux/lms/courses/selector';
import { selectLMSLearningPathsListItems } from '../../../../../redux/lms/learning-path/selector';
import { selectLMSModulesQueryItems } from '../../../../../redux/lms/modules/selector';
import { selectListItems } from '../../../../../redux/library/selector';
import { lmsModules } from '../../../../../redux/lms/modules/action';
import { lmsCollections } from '../../../../../redux/lms/collections/action';
import { lmsLearningPaths } from '../../../../../redux/lms/learning-path/action';
import { lmsCourses } from '../../../../../redux/lms/courses/action';
import PageLoader from '../../../../../components/PageLoader';
import ModuleComponent from '../components/module.component';


const ManagementLMSModule = () => {  
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params: any = useParams();
  const collectionsListItems = useSelector(selectLMSCollectionsListItems)
  const courseListItems = useSelector(selectLMScoursesListItems)
  const learningpathListItems = useSelector(selectLMSLearningPathsListItems)
  const lmsModulesQuery = useSelector(selectLMSModulesQueryItems);  
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const libraryData = useSelector(selectListItems);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectLMSModules, setSelectLMSModules] = useState<any>(  
    {
      "title": "",
      "description": "",
      "mappedTopics": {
        "mappedTopicIds": []
      },
      "mediaMappings": {
        "mediaFiles": [],
        "templates": []
      }
    }
  );

  const fetchLMSModulesQueryById = () => {  
    dispatch(lmsModules.query({  
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/modules/query`,  
      entity: 'lmsModules',
      jsonData: {
        records: [
          {
            id: params?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  };

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSModules({ ...selectLMSModules, [field]: event });
  };

  useEffect(() => {
    dispatch(lmsCollections.list({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/collections/list`,
      entity: 'lmsCollections',
      jsonData: {}
    })).then(() => {
      dispatch(lmsLearningPaths.list({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/learning-paths/list`,
        entity: 'lmsLearningPath',
        jsonData: {}
      }))
    }).then(() => {
      dispatch(lmsCourses.list({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses/list`,
        entity: 'lmsCourses',
        jsonData: {}
      }))
    }).then(() => {
      if (params?.id > 0) {
        fetchLMSModulesQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []
  )

  useEffect(() => {
    if (isQuery) {
      setSelectLMSModules(lmsModulesQuery?.result?.items);  
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (params?.id > 0) {
      await dispatch(lmsModules.resetAction({ actionType: 'update' }))
      await dispatch(lmsModules.update({  
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/modules`,  
        entity: 'lmsModules',
        jsonData: {
          records: [
            selectLMSModules
          ]
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(lmsModules.resetAction({ actionType: 'create' }))
      await dispatch(lmsModules.create({  
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/modules`,  
        entity: 'lmsModules',
        jsonData: {
          records: [
            selectLMSModules
          ]
        }
      })).then(() => {
        back();
      });
    }
  };

  const back = () => {
    navigate('/management/e-applications/lms/modules');  
  };

  return (
    <>
      {lmsModulesQuery?.isLoading ? <PageLoader /> :
        <ModuleComponent  
          handleInnerFormChange={handleInnerFormChange}
          selectLMSModules={selectLMSModules}  
          back={back}
          handleFormSubmit={handleFormSubmit}
          EntityTypeList={libraryData?.result?.LearningType}
          CollectionsList={collectionsListItems?.result?.items} 
          CourseList={courseListItems?.result?.items} 
          learningpathList={learningpathListItems?.result?.items} 
        />
      }
    </>
  );
};

export default ManagementLMSModule;  
